<template>
    <div style="background-color: #eeeeee;padding-bottom: 100px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner3.png" alt="">
        <div class="main">
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li @click="backPage('-1')">行业应用</li>
                <li>></li>
                <li>{{apply.name}}</li>
            </ul>
            <div class="content">
                <div class="menu">
                    <Menu :mebuActive="active" @changeBreadcrumb="changeBreadcrumb" />
                </div>
                <div class="apply">
                    <h2 class="tab_title title">{{ apply.name }}</h2>
                    <div class="editor" v-html="apply.content"></div>
                    <div class="editor" v-html="apply.description"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Menu from './compontents/menu.vue'
import {getApplyDetail} from '../../api/index'
export default{
    components: {
        Menu
    },
    data(){
        return{
            type:"",
            name:"",
            content:"",
            apply:{},
            active:null,
            id:"",
            content:""
        }
    },
    methods:{
        changeBreadcrumb(item){
            this.type = item.name
            // localStorage.setItem('type',this.type)
        },
        backPage(page){
            if(page == '-1'){
                this.$router.go(-1)
            }else{
                this.$router.push(page)
            }
        }
    },
    mounted(){
        this.active = this.$route.query.active
        console.log(this.active);
        this.id = this.$route.query.id
        getApplyDetail(this.id).then(res =>{
            this.apply = res.data
       })
    }


}
</script>
<style lang="scss" scoped>
.ql-snow .ql-tooltip[data-mode="img"]::before {
  content: "http://admin.cimomicro.com/prod-api:";
}
.content {
    display: flex;
    .menu {
        width: 250px;
    }
    .apply{
        padding: 0 20px;
        .title{
            margin-bottom: 30px;
            margin-top: 30px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/apply/applyDetail.vue